var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInputLine = function SvgInputLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.33341 14V12.6667H7.33341V3.33333H5.33341V2H10.6667V3.33333H8.66675V12.6667H10.6667V14H5.33341ZM12.0334 4.7L15.3334 8L12.0334 11.3L11.0907 10.3573L13.4481 8L11.0907 5.64267L12.0334 4.7ZM3.96675 4.7L4.90941 5.64267L2.55208 8L4.90941 10.3573L3.96675 11.3L0.666748 8L3.96675 4.7Z"
  }))));
};
export default SvgInputLine;